import { cloneElement } from 'react';
import { IconProps } from 'react-native-elements/dist/icons/Icon';
import {
  AntDesign,
  Entypo,
  EvilIcons,
  Feather,
  FontAwesome,
  FontAwesome6,
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
  SimpleLineIcons,
} from '@expo/vector-icons';

export type IconName = keyof typeof icons;

const icons = {
  accountCircle: <MaterialCommunityIcons name="account-circle" />,
  accountDetails: <MaterialCommunityIcons name="account-details" />,
  addUser: <AntDesign name="user-add" />,
  alertCircle: <Feather name="alert-circle" />,
  calendar: <MaterialCommunityIcons name="calendar-check" />,
  lock: <Feather name="lock" />,
  alertTriangle: <FontAwesome name="exclamation-triangle" />,
  arrowRight: <AntDesign name="arrow-right" />,
  arrowLeft: <AntDesign name="arrow-left" />,
  barChart: <FontAwesome name="area-chart" />,
  'book-open': <SimpleLineIcons name="book-open" />,
  bubble: <SimpleLineIcons name="bubble" />,
  caretRight: <FontAwesome6 name="caret-right" />,
  check: <Feather name="check" />,
  checkCircle: <Feather name="check-circle" />,
  checkCircleAlert: <MaterialIcons name="check-circle" />,
  checkboxCircleMarked: (
    <MaterialCommunityIcons name="checkbox-marked-circle" />
  ),
  checkboxCircleUnmarked: (
    <MaterialCommunityIcons name="checkbox-blank-circle-outline" />
  ),
  chevronUp: <Feather name="chevron-up" />,
  chevronDown: <Feather name="chevron-down" />,
  chevronLeft: <Entypo name="chevron-left" />,
  chevronRight: <Entypo name="chevron-right" />,
  circleInfo: <FontAwesome6 name="circle-info" />,
  clockFour: <FontAwesome6 name="clock-four" />,
  cloudDownload: <AntDesign name="cloud-download" />,
  close: <EvilIcons name="close" />,
  closecircle: <AntDesign name="close-circle" />,
  closesquare: <AntDesign name="close-square" />,
  cogOutline: <MaterialCommunityIcons name="cog-outline" />,
  copy: <Feather name="copy" />,
  delete: <MaterialIcons name="delete-outline" />,
  dislike: <AntDesign name="dislike" />,
  download: <AntDesign name="download" />,
  'ear-outline': <Ionicons name="ear-outline" />,
  edit: <Feather name="edit-3" />,
  email: <Entypo name="email" />,
  emailOutline: <Feather name="mail" />,
  envelope: <Feather name="mail" />,
  exclamationCircle: <EvilIcons name="exclamation" />,
  extLink: <Feather name="external-link" />,
  eye: <Feather name="eye" />,
  eyeOff: <Feather name="eye-off" />,
  fileText: <Ionicons name="document-text-outline" />,
  filter: <Feather name="filter" />,
  hash: <Feather name="hash" />,
  helpCircle: <Feather name="help-circle" />,
  home: <Entypo name="home" />,
  image: <FontAwesome6 name="image" />,
  images: <FontAwesome6 name="images" />,
  key: <Ionicons name="key" />,
  like: <AntDesign name="like" />,
  listening: <Ionicons name="ear-outline" />,
  logout: <MaterialIcons name="logout" />,
  noAccounts: <MaterialIcons name="no-accounts" />,
  nut: <MaterialCommunityIcons name="nut" />,
  password: <MaterialIcons name="password" />,
  'pencil-outline': <Ionicons name="pencil-outline" />,
  phone: <Feather name="phone" />,
  playCircle: <Feather name="play-circle" />,
  playCircleInverted: <FontAwesome name="play-circle" />,
  playOutline: <Ionicons name="play-outline" />,
  plus: <Feather name="plus" />,
  plusCircle: <Feather name="plus-circle" />,
  question: <MaterialIcons name="question-mark" />,
  reading: <SimpleLineIcons name="book-open" />,
  refresh: <Feather name="refresh-cw" />,
  save: <Feather name="save" />,
  send: <Feather name="send" />,
  settings: <Feather name="settings" />,
  shield: <Ionicons name="shield-outline" />,
  slash: <Feather name="slash" />,
  sliders: <FontAwesome6 name="sliders" />,
  snail: <MaterialCommunityIcons name="snail" />,
  speaker: <Feather name="volume-2" />,
  speaking: <SimpleLineIcons name="bubble" />,
  star: <FontAwesome name="star" />,
  trash: <Feather name="trash" />,
  trashAlt: <Feather name="trash-2" />,
  television: <FontAwesome name="tv" />,
  upArrowBox: <FontAwesome6 name="arrow-up-right-from-square" />,
  user: <FontAwesome name="user-circle" />,
  userPlus: <Feather name="user-plus" />,
  writing: <Ionicons name="pencil-outline" />,
  warningOutline: <Ionicons name="warning-outline" />,
  x: <Feather name="x" />,
};

export const Icon = ({
  name,
  ...props
}: IconProps & {
  name: IconName;
  scale?: number;
}) => {
  return cloneElement(icons[name] ?? icons['slash'], props);
};
